import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Lingua } from 'src/app/shared/models/bo.model';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { environment } from 'src/environments/environment';

import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  public sub: Subscription;
  public sub1: Subscription;
  public sub2: Subscription;
  public sub3: Subscription;
  public sub4: Subscription;
  public openSideMenuVisible: boolean;
  public menuTriggerVisible: boolean;
  public nomeAlbergoVisible: boolean;
  public currentLanguage: Lingua;
  public currentLangId: string;

  constructor(public headerService: HeaderService, public sessionService: SessionService, public localizationService: LocalizationService) { }

  ngOnInit() {
    this.currentLangId = this.localizationService.currentLanguage ? this.localizationService.currentLanguage.codice : 'it';
    this.currentLanguage = this.localizationService.currentLanguage;

    this.sub = this.localizationService.languageChanged.subscribe(() => {
      this.currentLangId = this.localizationService.currentLanguage ? this.localizationService.currentLanguage.codice : 'it';
      this.currentLanguage = this.localizationService.currentLanguage;
    });

    this.sub1 = this.headerService.drawerOpenedEvent.subscribe(() => setTimeout(() => {
      this.openSideMenuVisible = this.headerService.drawerClosed;
      this.menuTriggerVisible = this.headerService.menuTriggerVisible;
    }, 200));

    this.sub2 = this.headerService.drawerClosedEvent.subscribe(() => setTimeout(() => {
      this.openSideMenuVisible = this.headerService.drawerClosed;
      this.menuTriggerVisible = this.headerService.menuTriggerVisible;
    }, 200));

    this.sub3 = this.headerService.menuTriggerVisibleEvent.subscribe(() => setTimeout(() => {
      this.openSideMenuVisible = this.headerService.drawerClosed;
      this.menuTriggerVisible = this.headerService.menuTriggerVisible;
    }, 200));

    this.sub4 = this.headerService.nomeAlbergoVisibleEvent.subscribe((nomeAlbergoVisible: boolean) => setTimeout(() => {
      this.nomeAlbergoVisible = nomeAlbergoVisible;
    }, 200));
  }

  getClassEnviroment() {
    if (window.location.href.includes('homeOutlet') && this.sessionService.sessione != null && this.sessionService.sessione.oidAlbergoIniziale != null) {
      return 'albergoChanged';
    } else {
      return environment.environmentName;
    }
  }

  getVersione() {
    if (environment.environmentName == 'waf')
      return 'Versione TEST';

    if (environment.environmentName == 'localhost')
      return 'Versione DEBUG';

    return '';
  }

  setLanguage() {
    this.localizationService.setDefaultLang(this.currentLangId, true);
    this.currentLanguage = this.localizationService.currentLanguage;
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.sub1.unsubscribe();
    this.sub2.unsubscribe();
    this.sub3.unsubscribe();
    this.sub4.unsubscribe();
  }
}